import {useQuery} from 'react-query';
import {getPostChart} from 'services/myAd/chart';

const useGetChartPost = (guid: string) => {
  const {data: postChartData, isLoading} = useQuery(
    ['post-chart', guid],
    getPostChart,
  );
  return {postChartData, isLoading};
};

export default useGetChartPost;
